import { useMutation } from '@tanstack/react-query';
import { api } from '../services/api';

// Approve/Schedule post mutation
// params: { accessKey, postId, platforms, timezone }
export const useApprovePost = (onSuccess, onError) => {
  return useMutation({
    mutationFn: async ({ postId, platforms, timezone }) => {
      const res = await api.approvePost(postId, platforms, timezone);
      if (res?.error) {
        throw new Error(res.message || 'Failed to schedule post');
      }
      return res;
    },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onError: (error) => {
      if (onError) onError(error);
    },
  });
};

// Cancel approved/scheduled post — reverts post to draft
// params: { postId }
export const useCancelPost = (onSuccess, onError) => {
  return useMutation({
    mutationFn: async ({ postId, platforms, timezone }) => {
      const res = await api.cancelPost(postId, platforms, timezone);
      if (res?.error) {
        throw new Error(res.message || 'Failed to cancel post');
      }
      return res;
    },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onError: (error) => {
      if (onError) onError(error);
    },
  });
};

